export const supportCategoryList = [
  {
    label: 'Choose an option',
    value: ''
  },
  {
    label: 'How to lodge enquiry',
    value: 'How to lodge enquiry'
  },
  {
    label: 'General technical issue',
    value: 'General technical issue'
  },
  {
    label: 'Developer tools',
    value: 'Developer tools'
  },
  {
    label: 'Questions about service',
    value: 'Questions about service'
  },
  {
    label: 'Feedback',
    value: 'Feedback'
  },
  {
    label: 'Reports',
    value: 'Reports'
  },
  {
    label: 'Missing responses',
    value: 'Missing responses'
  },
  {
    label: 'Report damages',
    value: 'Report damages'
  },
  {
    label: 'Referral handling',
    value: 'Referral handling'
  },
  {
    label: 'AOI handling',
    value: 'AOI handling'
  }
];

export const supportCategoryListAssetOwner = [
  {
    label: 'Member admin management',
    value: 'Member admin management'
  },
  {
    label: 'Organisation configuration',
    value: 'Organisation configuration'
  },
  {
    label: 'Referral management',
    value: 'Referral management'
  },
  {
    label: 'Response management',
    value: 'Response management'
  }
];

export const supportCategoryListEnquirer = [
  {
    label: 'Request hardcopy of plans',
    value: 'Request hardcopy of plans'
  }
];
